<template>
    <table>
      <tr>
        <td>
          <l8-icon class="l8-icon" type="icon-feiji1" />
          {{ orgDst.departureName }}<l8-icon class="l8-icon l8-icon-dancheng"
            type="icon-dancheng" />{{ orgDst.arrivalName }}
        </td>
        <td>
          <l8-icon class="l8-icon" type="icon-rili1" />
          {{ orgDst.departureDate | format('M月D日') }}
        </td>
      </tr>
    </table>
</template>
<script>
export default {
  props: {
    orgDst: Object
  }
}
</script>
<style lang="less" scoped>

</style>
